// extracted by mini-css-extract-plugin
module.exports = {"container":"_35HJ5NfZ2BboIdW8ftW1bU","address":"_20-g9-Y65BQEGJaUfsz4C-","changeLink":"_3nqfXYLGB7jUMMIqrSjSf7","shouldSave":"_1PZGy8teMpIOiYpfA-gINN"};